import { XapiActivityState } from "../types";

export const serializeStateContent = (content: unknown): string =>
  content === null || content === undefined
    ? ""
    : typeof content === "string"
      ? content
      : JSON.stringify(content, null, 2);

export const parseStateContent = (
  text: string,
): { ok: true; value: unknown } | { ok: false } => {
  const trimmed = text.trim();
  if (trimmed === "") return { ok: true, value: null };
  try {
    return { ok: true, value: JSON.parse(trimmed) };
  } catch {
    return { ok: false };
  }
};

export const collectEditedStates = (
  original: XapiActivityState[],
  drafts: Record<string, string>,
): { states: XapiActivityState[]; invalidIds: string[] } => {
  const states: XapiActivityState[] = [];
  const invalidIds: string[] = [];
  original.forEach((state) => {
    const draft = drafts[state.id];
    if (draft === undefined || draft === serializeStateContent(state.content))
      return;
    const parsed = parseStateContent(draft);
    if (!parsed.ok) {
      invalidIds.push(state.id);
      return;
    }
    states.push({ id: state.id, content: parsed.value });
  });
  return { states, invalidIds };
};
